import locationsService from './locations-service'

const emptyState = () => ({
  locations: []
})

export default {
  namespaced: true,
  state: emptyState(),
  mutations: {
    CLEAN_UP (state) {
      state.locations.splice(0)
    },
    SET_LOCATIONS (state, locations) {
      state.locations.splice(0)
      if (locations && locations.length) {
        state.locations.push(...locations)
      }
    }
  },
  getters: {},
  actions: {
    cleanUp ({ commit }) {
      commit('CLEAN_UP')
    },
    setLocations ({ commit }, locations) {
      commit('SET_LOCATIONS', locations)
    },
    async retrieveLocations ({ commit, rootState }) {
      const companyId = rootState.login.user.userCompanyId
      const activeLocation = rootState.login.activeLocation
      let locations
      if (activeLocation && activeLocation.type === 'GROUP') {
        locations = await locationsService.getGroupTenants(companyId, activeLocation.id)
      } else {
        locations = await locationsService.getLocations(companyId)
      }
      commit('SET_LOCATIONS', locations)
    }
  }
}
